const tablesColumns = {};

export default tablesColumns;
